import Country from '../country/Country';
import SampleFirmwareRevision from '../sample-firmware-revision/SampleFirmwareRevision';
import Studio from '../studio/Studio';

export default class PhysicalSampleFirmwareUpgradeDTO {
  public firmwareUpgradeRequirement: string;
  public compatibleFirmwareRevision : SampleFirmwareRevision;
  public countries : Country[];
  public studios : Studio[];
  public immediate: boolean;
  public preSelectAll: boolean;

  constructor(firmwareUpgradeRequirement: string, compatibleFirmwareRevision: SampleFirmwareRevision, countries: Country[], studios: Studio[], immediate: boolean, preSelectAll: boolean) {
    this.firmwareUpgradeRequirement = firmwareUpgradeRequirement;
    this.compatibleFirmwareRevision = compatibleFirmwareRevision;
    this.countries = countries;
    this.studios = studios;
    this.immediate = immediate;
    this.preSelectAll = preSelectAll;
  }
  
}
